import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  get(key: string) {
    return localStorage.getItem(key);
  }

  set(key: string, value: any) {
    return localStorage.setItem(key, value);
  }

  remove(key: string) {
    return localStorage.removeItem(key);
  }

}

export enum STORAGE_KEYS {
  REDIRECT_URL = 'REDIRECT_URL',
  REDIRECT_DATA = 'REDIRECT_DATA'
}